/*
 * @Author: renbo
 * @Date: 2020-04-20 15:55:09
 * @LastEditTime: 2020-04-28 13:36:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-physician-vue/src/utils/snowGround.js
 */
import Cookies from 'js-cookie'
const userId = Cookies.get('native_organSign')
const env = process.env.VUE_APP_TITLE === 'production'
const appKey = env
  ? '2c3ce90ac745433fbe1462f6c3049b39'
  : '1eb3314bd58d45e8a364d2dc08185660'

;(function() {
  if (window.webSdk) return
  window.webSdk = []
  window.webSdk.methods = 'init identify track startTrack endTrack setSuperProperty'.split(' ')
  window.webSdk.factory = function(b) {
    return function() {
      var a = Array.prototype.slice.call(arguments)
      a.unshift(b)
      window.webSdk.push(a)
      return window.webSdk
    }
  }
  for (var i = 0; i < window.webSdk.methods.length; i++) {
    var key = window.webSdk.methods[i]
    window.webSdk[key] = window.webSdk.factory(key)
  }
  window.webSdk.load = function(b, x) {
    import ("@/utils/pc-sdk.js").then(() => {
      window.webSdk.init(b, x)
    })
  }

  window.webSdk.load(appKey, {
    // 配置应用的AppKey
    superProperty: {
      // 全局的事件属性(选填)
      应用名称: '灵芝-门店端H5'
    },
    debug: true, // 实时调试（默认false）
    autoTrack: false, // 启用全埋点采集（选填，默认false）
    autoScroll: false, // 是否监测页面滚动事件，启动autoTrack后生效（选填，默认false）
    singlePage: true, // 是否是单页面应用（SPA），启用autoTrack后生效（选填，默认false）
    platform: 'js' // 平台设置，js、h5（选填，默认js）
  })
  window.webSdk.identify(userId)
})()
